import styled from 'styled-components'
import Icon from '@mdi/react'

import { StyledHeaderWrapper } from 'components/Header/styles'
import theme from 'theme_'
import { Font14 } from 'components/Typography'

export const StyledLoginHeader = styled(StyledHeaderWrapper)`
  position: fixed;
  z-index: ${theme.zIndex.fixedHeader};
  padding-left: 24px;
  top: 0;
  left: 0;
  width: 100vw;
  height: ${theme.sizes.headerHeight};
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(p) =>
    p.shouldHaveBg ? theme.colors.menuDark : 'transparent'};
  transition: background-color 0.3s;

  > svg {
    display: block;
  }

  @media ${theme.devices.desktop} {
    height: ${theme.sizes.headerHeight};
  }
`

export const StyledLanguageWrapper = styled.div`
  width: 120px;
  flex: none;
  margin-left: ${theme.spacing.xs};
`

export const StyledHelpButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0;
  margin-left: ${theme.spacing.tiny};
  ${Font14};
  font-weight: 700;
  color: ${theme.colors.duneWarmGrey};
  border: none;
  background: transparent;
  cursor: pointer;

  :hover {
    color: ${theme.colors.horizonOrange};
  }

  @media ${theme.devices.tablet} {
    margin-left: ${theme.spacing.base};
  }
`
export const StyledHelpIcon = styled(Icon)`
  color: ${theme.colors.duneWarmGrey};
  margin-right: ${theme.spacing.tiny};

  @media ${theme.devices.tablet} {
    margin-right: ${theme.spacing.base};
  }
`
